import React, { useState } from "react";

import Button from "../../_components/button/Button";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";

const AudioFormats = () => {
  const formats = [
    {
      image: "https://cdn.pmlsound.com/anthem/avm90/images/dolby_atmos.jpg",
      name: "Dolby Atmos",
      description:
        "Sound has never sounded this good. Feel a deeper connection to the stories and music you love with sound that moves all around you with breathtaking realism.",
    },
    {
      image: "https://cdn.pmlsound.com/anthem/avm90/images/dts_x.jpg",
      name: "DTS:X",
      description:
        "DTS:X is the next-generation audio codec from DTS that leverages object-based audio to enable new audio experiences in immersion and interactivity.",
    },

    {
      image: "https://cdn.pmlsound.com/anthem/avm90/images/imax_2.jpg",
      name: "IMAX",
      description:
        "IMAX ENHANCED is the only way to experience IMAX’s signature picture, sound and scale in the home, IMAX Enhanced combines digitally remastered 4K HDR content and DTS audio technologies with best-in-class consumer electronics products and streaming platforms.",
    },
    {
      image: "https://cdn.pmlsound.com/anthem/avm90/images/dolby_vision.jpg",
      name: "Dolby Vision",
      description:
        "Feel the story’s full emotional impact, bringing your entertainment to life with an ultra-vivid picture, brighter highlights, and darker shadows.",
    },
  ];

  const [highlighted, setHighlighted] = useState(0);

  return (
    <section className="z-50 relative">
      <div
        className="bg-black py-12 px-5 md:py-20 bg-no-repeat bg-cover"
        style={{
          backgroundImage:
            "url(" +
            "https://cdn.pmlsound.com/anthem/avm90/images/audio_format_bg.jpg" +
            ")",
        }}
      >
        <div className="max-w-7xl mx-auto  " id="streaming_options">
          <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-white leading-snug z-50">
            Featuring the latest object-based audio and video formats
          </h4>

          <p className="text-xl  font-light text-center  text-white  mt-10">
            Dolby Atmos®, DTS:X®, DTS Virtual:X™, and IMAX® Enhanced processing
            are all supported to allow you to listen to all of your favourite
            audio formats up to 19-channels (15.4).
          </p>

          <div
            className="mx-auto xl:w-5/6  justify-center  grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-3  mt-10   h-0 invisible md:h-full  md:visible"
            style={{ zIndex: 100 }}
          >
            {formats.map((option) => (
              <div className="    rounded-sm bg-gray-200 shadow-md shadow-white/30 ">
                <div className="p-2">
                  <img src={option.image} className="h-max w-full" />
                  <h5 className="text-gray-900  text-xl font-bold py-4">
                    {option.name}
                  </h5>
                  <p class="text-gray-900  text-md font-light">
                    {option.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="md:h-0 visible   md:invisible">
            <div className="streaming_option w-3/4  rounded-md bg-gray-100 shadow-md shadow-white/50 m-auto">
              <div className="p-3">
                <img
                  src={formats[highlighted].image}
                  className="h-max w-full"
                />
                <h5 className="text-gray-900  text-xl font-bold py-4">
                  {formats[highlighted].name}
                </h5>
                <p class="text-gray-900  text-md font-light">
                  {formats[highlighted].description}
                </p>
              </div>
            </div>
            <div className="w-3/4 text-center mt-10 m-auto">
              <div className="grid    grid-cols-2 gap-4 justify-items-stretch">
                <div className="justify-self-end ">
                  <Button
                    name={<ChevronLeftIcon className="h-6 w-6" />}
                    dark={true}
                    centered={true}
                    width={"fit"}
                    handleClick={() => {
                      setHighlighted(highlighted - 1);
                    }}
                    disabled={highlighted == 0 ? true : false}
                  />
                </div>

                <div className="justify-self-start">
                  <Button
                    name={<ChevronRightIcon className="h-6 w-6" />}
                    dark={true}
                    centered={true}
                    width={"fit"}
                    handleClick={() => {
                      setHighlighted(highlighted + 1);
                    }}
                    disabled={formats.length - 1 == highlighted ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudioFormats;
